import React from "react";
import Loader from "../../../loader/Loader";
import Phone from "../../../assets/image/Phone.png";
import Mail from "../../../assets/image/Mail.png";
import Room from "../../../assets/image/Room.png";
import Person from "../../../assets/image/Person.png";
import { formatDateToDDMMYYYY } from '../../../utils/dateFormatter';

const isInteriorDesign = (service) =>
  service?.ServiceName?.toLowerCase().includes('interior design');

export default function BookingSummaryStep4({
  loading,
  selectedDate,
  selectedSlot,
  selectedService,
  selectedStore,
  Services,
  customerFirstName,
  customerLastName,
  customerPhone,
  customerEmail,
  building,
  area,
  city,
  selectedNumberofRooms,
  selectedServiceMode,
  totalPrice,
  idResidenceType,
  idRooms,
}) {
  if (totalPrice == null) return null;

  const matchedService = Services.find(
    (s) => s.ServiceName === selectedService.ServiceName
  );

  const formatted = Number(totalPrice).toFixed(2);
  const [whole, decimal] = formatted.split(".");

  return (
    <div className="step-4">
      {loading && <Loader />}

      {!loading && (
        <>
          <div className="booking-head">
            <div className="book-header">
              <h4>
                {formatDateToDDMMYYYY(selectedDate)} - {selectedSlot}{" "}
                <span className="status">Scheduled</span>
              </h4>
            </div>
          </div>

          <div className="booking-info-card">
            <div className="booking-info">
              <div className="info-card">
                <h4>Service Overview</h4>
                <div className="info-card-body">
                  <div className="select-info">
                    {matchedService && (
                      <>
                        <p className="strongtitle">
                          {matchedService.ServiceName}
                        </p>
                        <p>{matchedService.Description}</p>
                        <span className="price">
                          <span className="currency-sup">Dhs</span>
                          {whole}
                          {decimal && (
                            <span className="decimal-sub">.{decimal}</span>
                          )}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="info-card">
                <h4>Store Details</h4>
                <ul className="branch-info">
                  <li>{selectedStore.StoreLocation}</li>
                  <li>
                    <img src={Phone} alt="Phone" />
                    800 4532
                  </li>
                </ul>
              </div>
            </div>

            <div className="booking-customer-info">
              <h4>Customer Information</h4>

              <div className="customer-panel">
                <h5>
                  {(customerFirstName || "No Name")} {customerLastName || ""}
                </h5>
              </div>

              <ul className="customer-more-info">
                <li>
                  <img src={Phone} alt="Phone" /> {customerPhone || "No Phone"}
                </li>
                <li>
                  <img src={Mail} alt="Mail" /> {customerEmail || "No Email"}
                </li>

                {selectedService.ServiceName === "Measurement Service" && (
                  <li>
                    <img src={Room} alt="Room" />
                    No of Rooms: {selectedNumberofRooms?.value || ""}
                  </li>
                )}

                {selectedService.ServiceName === "Kitchen Planning Service" && (
                  <li>
                    <img src={Room} alt="Room" />
                    Service Mode: {selectedServiceMode?.value || ""}
                  </li>
                )}

                {isInteriorDesign(selectedService) && idResidenceType && (
                  <li>
                    <img src={Room} alt="Room" />
                    Residence: {idResidenceType}
                  </li>
                )}

                {isInteriorDesign(selectedService) && idRooms?.length > 0 && (
                  <li>
                    <img src={Room} alt="Room" />
                    Rooms:{" "}
                    {idRooms
                      .filter((r) => r.roomType)
                      .map((r) => `${r.roomType} ×${r.quantity}`)
                      .join(', ')}
                  </li>
                )}

                <li>
                  <img src={Person} alt="Address" />
                  {building || area || city ? (
                    <>
                      {building && <>{building}, </>}
                      {city && <>{city}, </>}
                      {area && <>{area}</>}
                    </>
                  ) : (
                    <>No Address</>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
